import Box, { BoxProps } from '@mui/material/Box'

const FADE_SIZE = 30

export default function Overflow({ children, sx = {}, ...props }: BoxProps) {
  const { paddingX, paddingY, ...outerSx } = sx as Record<string, unknown>
  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'hidden',
        maskImage: `linear-gradient(to bottom, transparent, black ${FADE_SIZE}px, black calc(100% - ${FADE_SIZE}px), transparent)`,
        WebkitMaskImage: `linear-gradient(to bottom, transparent, black ${FADE_SIZE}px, black calc(100% - ${FADE_SIZE}px), transparent)`,
        ...outerSx,
      }}
    >
      <Box
        component="div"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          paddingX: paddingX ?? 4,
          paddingY: paddingY ?? 4,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
